import React, { FC, useEffect, useState } from 'react';

import { Service } from '../../../store/_declarations/target';
import { serviceDescriptionApi } from '../../../store/api/services';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import Accordion from '../../atoms/Accordion';
import Checkbox from '../../atoms/Checkbox';
import Font from '../../atoms/Font';
import Icon from '../../atoms/Icon';
import Tooltip from '../../atoms/Tooltip';
import {
  IconWrapper,
  RadioButton,
  RadioButtonGroup,
  RadioButtonLabel,
  RadioButtonWrapper,
  ServiceListItemLabel,
  ServiceListItemTitleBar
} from './styles';

export type ServiceListItemProps = {
  checkboxProps?: {
    callback: (service: Service, b: boolean) => void;
    checked: boolean;
  };
  onChangeCategory?: (rootService: Service, optionService: Service) => void;
  service: Service;
};

const ServiceListItem: FC<ServiceListItemProps> = ({
  checkboxProps,
  onChangeCategory,
  service
}) => {
  const [selectedOption, setSelectedOption] = useState<Service | null>(
    service.otherServices && service.otherServices.length > 0
      ? service.otherServices[0]
      : null
  );
  const dispatch = useAppDispatch();
  const { services } = useAppSelector((state) => state.services);
  const { consumerPayload } = useAppSelector((state) => state.app);

  const handleOptionChange = (option: Service) => {
    setSelectedOption(option);
    if (
      service.otherServices &&
      service.otherServices.length > 0 &&
      onChangeCategory
    ) {
      onChangeCategory(service, option);
    }
  };

  useEffect(() => {
    if (service && service.otherServices && service.otherServices.length > 0) {
      setSelectedOption(service);
    }
  }, [service]);

  return (
    <Accordion
      description={
        services.find(
          (s) =>
            String(s.id) ===
            (selectedOption
              ? String(selectedOption?.zzService)
              : String(service.zzService))
        )?.text
      }
      label={
        <ServiceListItemLabel>
          {checkboxProps && (
            <Checkbox
              isChecked={checkboxProps.checked}
              onClick={(e) => {
                checkboxProps.callback(service, e.currentTarget.checked);
              }}
            />
          )}
          <ServiceListItemTitleBar>
            <Font
              customConfiguration={{ fontWeight: 700 }}
              variant="bodyRegular"
            >
              {selectedOption ? selectedOption.zzServDesc : service.zzServDesc}
            </Font>
            {service.otherServices && service.otherServices.length > 0 && (
              <IconWrapper>
                <Icon
                  data-testid="service-icon"
                  iconColor="brand1"
                  iconName="InterfacePencil"
                  iconSize="xs"
                />
              </IconWrapper>
            )}
          </ServiceListItemTitleBar>
        </ServiceListItemLabel>
      }
      triggerOnOpen={() => {
        if (service.otherServices && service.otherServices.length > 0) {
          service.otherServices.forEach((s) => {
            dispatch(
              serviceDescriptionApi({
                serviceDesc: {
                  countryCode:
                    consumerPayload?.context?.countryCode?.toUpperCase() || '',
                  serviceCode: s?.zzService
                }
              })
            );
          });
        } else {
          dispatch(
            serviceDescriptionApi({
              serviceDesc: {
                countryCode:
                  consumerPayload?.context?.countryCode?.toUpperCase() || '',
                serviceCode: service.zzService
              }
            })
          );
        }
      }}
    >
      {service.otherServices && service.otherServices.length > 0 ? (
        <RadioButtonGroup>
          <RadioButtonWrapper>
            <RadioButton
              checked={selectedOption?.zzService === service.zzService}
              id={`radio-${service.zzService}-${service.zzService}`}
              name={`options-${service.zzService}`}
              onClick={(e) => {
                e.stopPropagation();
                handleOptionChange(service);
              }}
            />
            <RadioButtonLabel
              htmlFor={`radio-${service.zzService}-${service.zzService}`}
            >
              <Font variant="bodyRegular">{service.zzServDesc}</Font>
              {services.find((s) => s.id === service.zzService)?.text && (
                <Tooltip
                  description={
                    services.find(
                      (s) => String(s.id) === String(service.zzService)
                    )?.text
                  }
                  label=""
                />
              )}
            </RadioButtonLabel>
          </RadioButtonWrapper>
          {service.otherServices.map((option, index) => (
            <RadioButtonWrapper key={index}>
              <RadioButton
                checked={selectedOption?.zzService === option.zzService}
                id={`radio-${service.zzService}-${index}`}
                name={`options-${service.zzService}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOptionChange(option);
                }}
              />
              <RadioButtonLabel htmlFor={`radio-${service.zzService}-${index}`}>
                <Font variant="bodyRegular">{option.zzServDesc}</Font>
                {services.find((s) => s.id === option.zzService)?.text && (
                  <Tooltip
                    description={
                      services.find(
                        (s) => String(s.id) === String(option.zzService)
                      )?.text
                    }
                    label=""
                  />
                )}
              </RadioButtonLabel>
            </RadioButtonWrapper>
          ))}
        </RadioButtonGroup>
      ) : null}
    </Accordion>
  );
};

export default ServiceListItem;
